import { Fancybox } from "@fancyapps/ui";

import MobileNavigation from "./components/MobileNavigation";
import ResponsiveImages from "./components/ResponsiveImages";
import CookieBar from "./components/CookieBar";
import InView from "./components/InView";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import JustifiedGallery from "./components/JustifiedGallery";
import Slider from "./components/Slider";
import Search from "./components/Search";
import ProductSearch from "./components/ProductSearch";
import Accordion from "./components/Accordion";
import CareInstructionsForm from "./components/CareInstructionsForm";
import NewsletterForm from "./components/NewsletterForm";
import client from './vendor/shopify/client';
import { createData, createStore } from './vendor/shopify/alpine';
import Alpine from 'alpinejs/dist/module.esm.js';

document.addEventListener("DOMContentLoaded", (event) => {
    window.Alpine = Alpine;
    createStore(Alpine);
    createData(Alpine);
    Alpine.start();

    new Header();
    new Hero();
    new MobileNavigation();
    new ResponsiveImages();
    new CookieBar();
    new InView();
    new Form();
    new JustifiedGallery();
    new Slider();
    new Search();
    new Accordion();
    new CareInstructionsForm();
    new NewsletterForm();
});
